export const COLUMNSCOMITES = [
    {
        header: 'Fecha',
        accessorKey: 'new_fecha',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Organismo o institución convocante',
        accessorKey: '_new_institucinconvocante_value',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Tipo de evaluación',
        accessorKey: 'new_tipodeevaluacin',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: 'Lugar',
        accessorKey: 'new_lugar',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
]